import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const prompts = ['Late checkout request detected → Approved based on VIP tier', 'Maintenance issue logged → Auto-dispatched nearest technician', 'Missed upsell opportunity → Follow-up sequence triggered', 'Document bottleneck detected → Auto-escalated to senior associate', 'Fleet deviation alert → Route recalculated and port notified'];
export function LiveAgentStrip() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % prompts.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <div className="w-full bg-[#050505] relative z-20 -mt-10 mb-10" data-id="element-344">
      <div className="max-w-4xl mx-auto px-6" data-id="element-345">
        <div className="bg-[#0A0A0A]/80 backdrop-blur-md border border-white/10 rounded-full py-3 px-6 flex items-center gap-4 shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-346">
          <div className="relative flex items-center justify-center flex-shrink-0" data-id="element-347">
            <div className="w-2 h-2 rounded-full bg-brand-orange absolute animate-ping opacity-75" data-id="element-348" />
            <div className="w-2 h-2 rounded-full bg-brand-orange relative z-10" data-id="element-349" />
          </div>

          <div className="flex-1 overflow-hidden h-6 relative" data-id="element-350">
            <AnimatePresence mode="wait" data-id="element-351">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.5,
              ease: 'easeInOut'
            }} className="absolute inset-0 flex items-center" data-id="element-352">
                <p className="text-xs md:text-sm text-gray-400 font-mono tracking-wider truncate" data-id="element-353">
                  {prompts[currentIndex]}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>;
}